import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import { useEffect } from 'react'
import { useTranslate } from '@repo/unicity'
import Box from '@mui/material/Box'

// Get base URL from Vite config (e.g., '/')
const baseUrl = import.meta.env.BASE_URL

const PhotoGallery = () => {
    const { translate } = useTranslate()
    const photos = [
        {
            href: `${baseUrl}assets/gallery/Pic1.jpg`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic1_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic2.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic2_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic3.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic3_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic4.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic4_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic5.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic5_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic6.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic6_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic7.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic7_thumbnail.png`
        },
        {
            href: `${baseUrl}assets/gallery/Pic8.png`,
            width: 1000,
            height: 563,
            thumbnail: `${baseUrl}assets/gallery/Pic8_thumbnail.png`
        }
    ]

    useEffect(() => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '#photo-gallery',
            children: 'a',
            pswpModule: () => import('photoswipe')
        })
        lightbox.init()

        return () => {
            lightbox.destroy()
        }
    }, [])

    return (
        <Stack bgcolor={'secondary.main'}>
            <Stack p={'48px 24px'} gap={3}>
                <Typography variant="h1" color="primary.main" textTransform={'uppercase'} textAlign={'center'}>
                    {translate('photo_gallery')}
                </Typography>
                <Typography variant="body1" color="primary.dark" textAlign={'center'}>
                    {translate('photos_from_the_event')}
                </Typography>
            </Stack>

            <Stack
                display={'flex'}
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={'4px'}
                className="pswp-gallery"
                id="photo-gallery"
                sx={{
                    justifyContent: 'center',
                    maxWidth: '500px',
                    margin: '0 auto',

                    img: {
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover',
                        aspectRatio: '212 / 140',
                        display: 'block'
                    },
                    '.gallery-item': {
                        flex: '0 0 calc(50% - 2px)', // 2 columns with 4px gap
                        aspectRatio: '212 / 140',
                        overflow: 'hidden'
                    },

                    // 430px - 489px
                    '@media (max-width: 489px)': {
                        maxWidth: '430px'
                    },

                    // 414px - 429px
                    '@media (max-width: 429px)': {
                        maxWidth: '414px'
                    },

                    // 390px - 413px
                    '@media (max-width: 413px)': {
                        maxWidth: '390px'
                    },

                    // 375px - 389px
                    '@media (max-width: 389px)': {
                        maxWidth: '375px'
                    },

                    // < 375px
                    '@media (max-width: 374px)': {
                        maxWidth: '100%',
                        padding: '0 8px'
                    }
                }}>
                {photos.map(photo => (
                    <Box key={photo.href} className="gallery-item">
                        <a href={photo.href} data-pswp-width={photo.width} data-pswp-height={photo.height}>
                            <img src={photo.thumbnail} alt={photo.href} />
                        </a>
                    </Box>
                ))}
            </Stack>
        </Stack>
    )
}

export default PhotoGallery
